const paths = {
  redirect: {
    application: '/redirect/application',
  },
  auth: {
    _: '/auth',
    redirectToKeyCloak: `/api/v1/auth/merchant/redirect/self-onboarding`,
    merchantAuthCallback: '/merchantAuthCallback',
    merchantVerify: '/verify',
    merchantVerifyOption2: '/verify/',
    merchantInviteAuthCallback: '/merchantInviteAuthCallback',
    redirectAgentToKeyCloak: `/api/v1/auth/merchant/redirect/agent-signup`,
    agentAuthCallback: '/agentAuthCallback',
  },
  home: {
    _: '/',
    application: '/home/application',
    validate: '/validate',
  },
  companyType: {
    _: '/companyType',
  },
  letsStart: {
    _: '/letsStart',
  },
  getInTouch: {
    _: '/getInTouch',
  },
  wizard: {
    _: '/wizard',
    helpCenter: '/wizard/helpCenter',
    services: '/wizard/services',
    application: '/wizard/application',
    signContract: '/wizard/signContract',
    payment: '/wizard/payment',
    completion: '/stageResult',
  },
  stageResult: {
    _: '/stageResult',
    waitingForScreening: '/stageResult/waitingForScreening',
    error: '/stageResult/error',
    screeningError: '/stageResult/screeningError',
    screeningReject: '/stageResult/screeningReject',
    salesforceSoftDecline: '/stageResult/salesforceSoftDecline',
    salesforceHardDecline: '/stageResult/salesforceHardDecline',
    submit: '/stageResult/submit',
    salesforceError: '/stageResult/salesforceError',
    salesforceTechnicalError: '/stageResult/salesforceTechnicalError',
    completed: '/stageResult/completed',
    successfulOnboarding: '/stageResult/successfulOnboarding',
    unknownStage: '/stageResult/unknownStage',
  },
  agent: {
    _: '/agent',
    leads: '/agent/leads',
    applications: '/agent/applications',
    map: '/agent/map',
  },

  sales: {
    _: '/sales',
    table: '/sales/table',
  },

  // KSA
  ksa: {
    dataValidation: {
      _: '/ksa/dataValidation',
      smsotp: '/ksa/dataValidation/verification/:smsOtpChallengeId/:mobileNumber',
      error: '/ksa/dataValidation/error/:errorType',
    },
    getStarted: {
      _: '/ksa/getStarted',
    },
    invitation: {
      _: '/ksa/invitation',
      smsotp: '/ksa/invitation/smsotp/:smsOtpChallengeId',
      error: '/ksa/invitation/error/:errorType',
      existingUser: '/ksa/invitation/existingUser',
      letsStart: '/ksa/invitation/letsStart',
    },
    _: '/ksa',
    initialInformation: '/ksa/initialInformation',
    application: '/ksa/application',
    review: '/ksa/review',
    reviewSuccess: '/ksa/reviewSuccess',
    reviewReject: '/ksa/reviewReject',
    reviewResubmit: '/ksa/reviewResubmit',
    terminated: '/ksa/terminated',
    services: '/ksa/products',
    startInMinutes: '/ksa/startInMinutes',
    contract: '/ksa/agreement',
    payment: '/ksa/payment',
    completion: '/ksa/completion',
    contactUs: '/ksa/contactUs',
  },
};

export default paths;
